<template>
  <div>

    <div class="tw-text-gray-700 tw-my-5 tw-text-sm">
      Enter your new password. Make sure your password is unique and different from your previous passwords.
    </div>

    <b-form-group label="Old Password" label-class="text-truncate label-required">
      <b-form-input v-model="currentPassword" type="password" required/>
    </b-form-group>

    <password-field v-model="password"
                    label="New Password"
                    @newPasswordMessages="newPasswordMessages = arguments[0]"/>

    <b-form-group label="Confirm Password" label-class="text-truncate label-required" class="tw-relative">
      <b-form-input v-model="passwordConfirmation" type="password" required :state="confirmPasswordValid"
                    @focus="confirmPasswordFocused = true" @blur="confirmPasswordFocused = false"/>
      <b-form-invalid-feedback>
        Password must match confirmation
      </b-form-invalid-feedback>
    </b-form-group>
  </div>
</template>

<script>
import PasswordField from "./PasswordField.vue";

export default {
  components: {
    PasswordField
  },

  data: function () {
    return {
      currentPassword: null,
      password: null,
      passwordConfirmation: null,
      newPasswordFocused: false,
      confirmPasswordFocused: false,
      newPasswordMessages: [],
    }
  },

  created() {
    this.resetForm();
  },

  methods: {
    resetForm() {
      this.password = null;
      this.passwordConfirmation = null;
      this.currentPassword = null;
    }
  },

  watch: {
    validSubmit() {
      this.$emit('validPassword', this.validSubmit);
    }
  },

  computed: {
    validSubmit() {
      return this.newPasswordValid && this.confirmPasswordValid && this.currentPassword && this.currentPassword.length;
    },

    showNewPasswordPopup() {
      return this.password && this.password.length && !this.newPasswordValid && this.newPasswordFocused;
    },

    newPasswordValid() {
      if (!this.password || !this.password.length) {
        return null;
      }

      return this.newPasswordMessages.every(item => item.valid);
    },

    confirmPasswordValid() {
      if (this.passwordConfirmation && this.passwordConfirmation.length && this.newPasswordValid) {
        return this.passwordConfirmation === this.password;
      }
      return null
    },

    params() {
      return {
        password: this.password,
        password_confirmation: this.passwordConfirmation,
        current_password: this.currentPassword,
      }
    },


  }
}
</script>
